import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

const CompactTextField: React.FC<TextFieldProps> = (props) => {
  return <TextField {...props} size="small" margin="dense" />;
};

export default CompactTextField;

export {}; // fuerza módulo
